import React from 'react'
import InstructorNavbar from '../components/instructor/InstructorNavbar'
import InstructorCourseAssignments from '../components/instructor/InstructorCourseAssignments'

const InstrucotrCourseAssignmentsPage = () => {
  return (
    <>
    <InstructorNavbar/>
    <InstructorCourseAssignments/>
    </>
  )
}

export default InstrucotrCourseAssignmentsPage